import { render, staticRenderFns } from "./NotificationDetail.vue?vue&type=template&id=b3b09856&scoped=true&"
import script from "./NotificationDetail.vue?vue&type=script&lang=js&"
export * from "./NotificationDetail.vue?vue&type=script&lang=js&"
import style0 from "./NotificationDetail.vue?vue&type=style&index=0&id=b3b09856&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b09856",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
